import { AssetSectionDto } from '@picflow/types';
import { ScreenSizes } from '../classes/screen-sizes.class';
import { getGalleryWidth } from '../gallery/lib/get-gallery-width';
import { assetSectionSizes } from './default-asset-section';

const getPreset = (section: AssetSectionDto) => {
  const sizes = Object.entries(assetSectionSizes).map(v => ({
    key: v[0],
    val: v[1],
  }));

  let preset = sizes[0];
  let diff = Math.abs(preset.val - section.display_size);
  sizes.forEach(size => {
    const _diff = Math.abs(size.val - section.display_size);
    if (_diff < diff) {
      diff = _diff;
      preset = size;
    }
  });
  return preset;
};

const getMobileColumnCount = (section: AssetSectionDto) => {
  const preset = getPreset(section);
  if (preset.key === 'small') return 3;
  if (preset.key === 'medium') return 2;
  if (preset.key === 'large') return 1;
  throw 'Unhandled preset';
};

export const calcColumnCount = (section: AssetSectionDto, galleryWidth?: number) => {
  const screenSize = ScreenSizes.screenSize();
  if (screenSize === 'mobile') return getMobileColumnCount(section);
  if (!galleryWidth) galleryWidth = getGalleryWidth(section);
  const columns = Math.floor((galleryWidth / (section.display_size * section.display_size)) * 4);
  return Math.max(getMobileColumnCount(section), columns);
};
